import { type ComponentProps } from 'react';
import { Root, Indicator } from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '@/util/utils';

/** ui-checkbox: 16px, 4px radius, primary when checked or indeterminate. */
function Checkbox({ className, ref, ...props }: ComponentProps<typeof Root>) {
    return (
        <Root
            data-slot="checkbox"
            ref={ref}
            className={cn(
                'peer group/checkbox bg-card border-input size-4 shrink-0 rounded-xs border',
                'focus-visible:outline-ring transition-[color,box-shadow] duration-(--duration-fast) outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid',
                'data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground',
                'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:text-primary-foreground',
                'aria-invalid:border-destructive disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        >
            <Indicator
                data-slot="checkbox-indicator"
                className="flex items-center justify-center text-current"
            >
                <Check className="size-3 group-data-[state=indeterminate]/checkbox:hidden" />
                <Minus className="hidden size-3 group-data-[state=indeterminate]/checkbox:block" />
            </Indicator>
        </Root>
    );
}

export { Checkbox };
